import { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";
import { format } from "date-fns";
import TaskManagementIcon from "../assets/action-items/taskManagement.svg";
import RightArrowIcon from "../assets/common/right-arrow-icon.svg";
import { Box } from "@mui/system";
import TaskManagement from "../components/ActionItems/TaskManagement";
import AppNotification from "../components/Common/AppNotification";
import TaskNotifications from "../components/ActionItems/TaskNotifications";
import useGlobalContext from "../context/useGlobalContext";
import { useNotificationCount } from "../hooks/useNotificationCount";
import SupportIcon from "../assets/common/support-icon.svg";
import "../styles/actionItems.css";
import { Tooltip, Typography } from "@mui/material";
import { DateRangeValue } from "../utils/types";
import ClientAsk7G from "../components/ClientOverview/ClientAsk7G";


const TaskManagementPage = () => {
    const { accountDetails } = useContext(GlobalContext);
    const [taskManagementDateRange, setTaskManagementDateRange] = useState<DateRangeValue>({ preset: "currentWeek", startDate: "", endDate: "" });
    const [isSupportTicketOpen, setIsSupportTicketOpen] = useState<boolean>(false);
      const userProfileOrgId = accountDetails?.profileOrgId ?? "";
      const { featureMap } = useGlobalContext();
      const isNotificationsEnabled = featureMap?.notification_settings === true;
      const userNotification = useNotificationCount(userProfileOrgId, isNotificationsEnabled);
      const isSupportTaskEnabled = featureMap?.support_task === true;

    const location = useLocation();
    const pathParts = location.pathname.split("/"); 
    const lastPart = pathParts[pathParts.length - 1];

    const taskManagementLabel: Record<string, string> = {
        "all-tasks": "Task Overview",
        "my-tasks": "My Tasks",
        "team-tasks": "Team's Tasks",
        "subscribed-tasks": "Subscribed Tasks",
        "complete-mom-tasks": "Complete MoM Tasks",
        "ai-recommended-tasks": "AI Recommended Tasks",
    };
    const taskManagementRef = useRef<any>(null);
    const Ask7GEnabled = featureMap?.business_ask7g === true;
    const [isAsk7GExpanded, setIsAsk7GExpanded] = useState(false);

    useEffect(() => {
      setIsAsk7GExpanded(false);
    }, [location.pathname, location.search]);

    return (
        <Box
            id="meetingsParent"
            className="flex flex-col justify-start items-start gap-6 m-2"
            style={{ width: "auto" }}
            >
            <Box
                sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "10px",
                }}
            >
                <Box
                className="interaction-breadcrumbs"
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "8px",
                }}
                >
                <Box
                    component={isAsk7GExpanded ? "button" : "div"}
                    type={isAsk7GExpanded ? "button" : undefined}
                    className={`flex flex-row justify-start items-center gap-2 ask7g-home-breadcrumb ${
                        isAsk7GExpanded ? "ask7g-home-breadcrumb--expanded" : "ask7g-home-breadcrumb--collapsed"
                    }`}
                    onClick={isAsk7GExpanded ? () => setIsAsk7GExpanded(false) : undefined}
                    >
                    <img src={TaskManagementIcon} alt="" height={16} width={16} className="breadCrumbs-icon"/>
                    <h2>Task</h2>
                </Box>

                {taskManagementLabel[lastPart] && !isAsk7GExpanded && (
                    <>
                    <img src={RightArrowIcon} alt="" style={{ marginTop: "3px" }} />
                    <h1 className="interactions-title">
                        {taskManagementLabel[lastPart]}
                        <span className="interactions-date-range">
                        {taskManagementDateRange?.startDate && taskManagementDateRange?.endDate && (
                        <>
                            {taskManagementDateRange?.overdue ? (
                            <> {" "} (As of today)</>
                            ) : (
                            taskManagementDateRange?.startDate &&
                            taskManagementDateRange?.endDate && (
                                <>
                                {" "}
                                (
                                {format(new Date(taskManagementDateRange.startDate), "MMM dd yyyy")} -{" "}
                                {format(new Date(taskManagementDateRange.endDate), "MMM dd yyyy")})
                                </>
                            )
                            )}
                        </>
                        )}
                        </span>
                    </h1>
                    </>
                )}
                {Ask7GEnabled && isAsk7GExpanded && (
                    <>
                        <img src={RightArrowIcon} alt="" style={{marginTop: "3px"}} />
                        <Typography className="breadCrumbs-text ask7g-current-breadcrumb" sx={{fontSize: "16px"}}>
                        Ask 7G
                        </Typography>
                    </>
                    )}
                </Box>
                <div className="flex items-center gap-3">
                {(taskManagementLabel[lastPart] !== "Complete MoM Tasks" && taskManagementLabel[lastPart] !== "AI Recommended Tasks")&& !isAsk7GExpanded && (
                <button
                    onClick={() => {
                        setIsSupportTicketOpen(false);
                        taskManagementRef.current?.clearGroupByValues();
                        taskManagementRef.current?.openAddTask();
                    }}
                    className="add-action-btn"
                    >
                    Add Task
                </button>
                )}
                {isSupportTaskEnabled && !isAsk7GExpanded && (
                <Tooltip title = "Create a support ticket" placement = "bottom" arrow>
                    <div className="suppoet__icon__container"
                    onClick={()=>{
                        setIsSupportTicketOpen(true)
                            taskManagementRef.current?.clearGroupByValues();
                            taskManagementRef.current?.openAddTask();
                    }}
                    >
                        <img src={SupportIcon} alt="" />
                    </div>
                </Tooltip>
                )}
                {isNotificationsEnabled && (
                        <AppNotification
                        notificationCount= {userNotification.notificationCount}
                        notificationApiRefetch = {userNotification.getNotificationCountRefetch}
                        contentComponent={<TaskNotifications userNotification={userNotification}/>}
                        />
                    )}
                {Ask7GEnabled && (
                    <ClientAsk7G
                        view="icon"
                        isExpanded={isAsk7GExpanded}
                        onToggleExpand={setIsAsk7GExpanded}
                    />
                )}
                </div>
            </Box>
        {Ask7GEnabled && (
            <Box sx={{ width: "100%", display: isAsk7GExpanded ? "block" : "none" }}>
            <ClientAsk7G
                view="full"
                isExpanded={isAsk7GExpanded}
                onToggleExpand={setIsAsk7GExpanded}
            />
            </Box>
        )}
        <Box sx={{ display: isAsk7GExpanded ? "none" : "block", width: "100%" }}>
        <TaskManagement setTaskManagementDateRange = {setTaskManagementDateRange}  ref={taskManagementRef} 
        isSupportTicketOpen={isSupportTicketOpen}
        setIsSupportTicketOpen={setIsSupportTicketOpen}
        />
        </Box>
        </Box>
    );
};

export default TaskManagementPage;
